import React, { Component } from 'react';

// import Custom Componenets
import BootstrapTable from 'react-bootstrap-table-next';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';

// koneksi
import API_URL, { Post, Delete, Get, JENIS_DESA, ID_DESA, } from '../../../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import axios from 'axios';
import Datetime from 'react-datetime';

import L from 'leaflet';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import ReactSelect from 'react-select';

let DefaultIcon = L.icon({
	iconSize: [25, 41],
	iconAnchor: [10, 41],
	iconUrl: icon,
	shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

const currentDate = new Date();
Date.prototype.addDays = function (days) {
	var date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
}

const frmDex = {
	uuid: '',
	tahun: new Date().getFullYear(),
	bulan: null
}
const dateFormat = require('dateformat');

const optionKewarganegaraan = {
	WNI: "Warga Negara Indonesia ( WNI )",
	WNA: "Warga Negara Asing ( WNA )"
}
const optionDapatMembaca = {
	L: "Latin",
	D: "Daerah",
	A: "Arab",
	AL: "Arab dan Latin",
	ALD: "Arab, Latin dan Daerah",
}

class MenuB3 extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			pagination: [],
			listPenduduk: [],
			tmplistPenduduk: {},
			detailPenduduk: null,
			status: {
				form: false,
				btnForm: false,
				btnAksi: false
			},
			loading: false,
			loadingPreview: false,
			imagePreview: null,
			cetakPreview: false,
			detailPreview: false,
			detailData: null,
			awal: '',
			sebelum: '',
			hal: [],
			setelah: '',
			akhir: '',
			dt: frmDex,
			judul: 'Tambah Penduduk ' + JENIS_DESA,
			optionKewarganegaraan: optionKewarganegaraan,
			optionDapatMembaca: optionDapatMembaca,
			textCari: '',
			listTahun: [],
			// tahunCetak: new Date().getFullYear(),
			tahunCetak: null,
			bulanCetak: null,
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			editMode: false
		};
	}

	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================

	pagination = data => {
		// const data = this.state.pagination;
		//console.log(data);
		let awal = "";
		let hal = [];
		let sebelum = "";
		let setelah = "";
		let akhir = "";
		if (data.total > 0) {
			let start = 1;
			let end = 5;
			let n = 0;
			let p = 0;
			if (data.current_page <= 3) {
				start = 1;
				end = 5;
				if (data.last_page > data.current_page) {
					n = data.current_page + 1;
				}
			} else {
				p = data.current_page - 1;
				n = data.current_page + 1;
				start = data.current_page - 2;
				end = data.current_page + 2;
			}
			if (end >= data.last_page - 2) {
				p = data.current_page - 1;
				if (start >= 5) {
					start = data.last_page - 4;
				}
				end = data.last_page;
			}

			for (let i = start; i <= end; i++) {
				let warna = "primary-custom";
				if (i === data.current_page) {
					warna = "danger";
				}
				hal.push(
					<a
						onClick={() => this.fetch({ page: i })}
						className={
							"btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
						}
					>
						{i}
					</a>
				);
			}
			if (p > 0) {
				sebelum = (
					<a
						onClick={() => this.fetch({ page: p })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{"<"}
					</a>
				);
			}
			if (n > 0) {
				setelah = (
					<a
						onClick={() => this.fetch({ page: n })}
						className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
					>
						{">"}
					</a>
				);
			}
			awal = (
				<a
					onClick={() => this.fetch({ page: 1 })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{"<<"}
				</a>
			);
			akhir = (
				<a
					onClick={() => this.fetch({ page: data.last_page })}
					className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
				>
					{">>"}
				</a>
			);
		}
		this.setState({ awal, sebelum, hal, setelah, akhir });
	};

	fetch = (params = {}) => {
		this.setState({ loading: true })
		let link = "";
		if (params.page) {
			switch (params.page) {
				case ">>":
					link =
						"?page=" +
						Math.ceil(
							this.state.pagination.total / this.state.pagination.per_page
						);
					break;
				case ">":
					link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
					break;
				case "<":
					link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
					break;
				case "<<":
					link = "?page=1";
					break;
				default:
					link = "?page=" + params.page;
					break;
			}
		}

		// if (this.state.textCari === '') {
		// 	Get("penduduk" + link, null, dtkat => {
		// 		console.log("dtkat", dtkat);

		// 		if (dtkat.results) {
		// 			this.setState({
		// 				data: dtkat.results.data,
		// 				pagination: dtkat.results,
		// 				loading: false
		// 			})
		// 			this.pagination(dtkat.results);
		// 		}

		// 	});
		// } else { // Jika pencarian
		Post("buku-rekapitulasi-jumlah-penduduk" + link, null, {
			q: this.state.textCari
		}, dtkat => {
			console.log(dtkat);
			if (dtkat.data.results) {
				console.log('masuk');
				this.setState({
					data: dtkat.data.results.data,
					pagination: dtkat.data.results,
					loading: false
				})
				this.pagination(dtkat.data.results);
			}

		});
		// }

	};

	handleCetak = ((e) => {
		e.preventDefault()

		if (this.state.tahunCetak && this.state.bulanCetak) {
			this.setState({ loading: false, cetakPreview: false })
			this.downloadSurat()
		} else {
			const alertData = {
				show: true,
				basicType: "info",
				basicTitle: "Data Belum Lengkap",
				pesanAlert: "Mohon isi seluruh data dengan benar"
			}
			this.setState(alertData)
		}
	})

	// ================== simpan data ==================
	simpan = ((e) => {
		e.preventDefault();

		if (this.state.dt.tahun && this.state.dt.bulan) {
			this.setState({ loadingPreview: true })
			console.log(this.state.dt);


			let bodyData = this.state.dt
			bodyData = {
				...bodyData,
				bulan: bodyData.bulan.value,
			}
			let psn = "ubah";
			let resstat = 201;
			let metode = "create";
			if (bodyData.uuid === "") {
				psn = "tambah";
				resstat = 201;
				bodyData.uuid = null;
			} else {
				psn = "ubah";
				resstat = 200;
				metode = "update";
			}

			console.log(bodyData);

			Post('buku-rekapitulasi-jumlah-penduduk/' + metode, bodyData.uuid, bodyData, res => {
				// console.log(res);
				// console.log(resstat);
				if (res.status == 200 || res.status == 201) {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "success",
						basicTitle: "Data Penduduk " + JENIS_DESA,
						pesanAlert: "Berhasil " + psn + " Data"
					});

					document.getElementById('form-data').reset()
					this.fetch();
					this.setState({
						dt: frmDex,
						status: {
							...this.state.status,
							form: false
						}
					})
				} else {
					this.setState({
						loadingPreview: false,
						show: true,
						basicType: "danger",
						basicTitle: "Data Penduduk " + JENIS_DESA,
						pesanAlert: "Gagal " + psn + " Data"
					});
				}
			})

		} else {
			this.setState({
				show: true,
				basicType: "warning",
				basicTitle: "Data Rekapitulasi Jumlah Penduduk " + JENIS_DESA,
				pesanAlert: "Isi data kewarganegaraan"
			});
		}

	});
	// ========================================================================

	bukaForm = () => {
		this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
	};

	tutupForm = () => {
		this.setState({
			formDisposisi: false,
			status: {
				...this.state.status,
				form: false,
			},
		})
		// document.getElementById('form-data').reset()
		this.forceUpdate();
	};



	ubahData = data => {
		// console.log(data);
		this.setState({
			judul: "Ubah Data Penduduk " + JENIS_DESA,
			editMode: true
		})

		if (data) {
			let extra = {
				dapat_membaca: '',
				kewarganegaraan: null,
				// keterangan: '',
			}

			let extra2 = {
				datang_dari: "",
				tanggal_datang: null,
				pindah_ke: "",
				tanggal_pindah: null,
				meninggal: "",
				tanggal_meninggal: null,
				keterangan: '',
			}

			if (data.data_penduduk_detail) {
				extra = {
					dapat_membaca: data.data_penduduk_detail.dapat_membaca,
					kewarganegaraan: {
						value: data.data_penduduk_detail.kewarganegaraan,
						label: optionKewarganegaraan[data.data_penduduk_detail.kewarganegaraan],
					},
				}
			}

			if (data.data_penduduk_mutasi) {
				extra2 = {
					datang_dari: data.data_penduduk_mutasi.datang_dari,
					pindah_ke: data.data_penduduk_mutasi.pindah_ke,
					keterangan: data.data_penduduk_mutasi.keterangan,

					tanggal_datang: data.data_penduduk_mutasi.tanggal_datang ? new Date(data.data_penduduk_mutasi.tanggal_datang) : null,
					tanggal_pindah: data.data_penduduk_mutasi.tanggal_pindah ? new Date(data.data_penduduk_mutasi.tanggal_pindah) : null,
					tanggal_meninggal: data.data_penduduk_mutasi.tanggal_meninggal ? new Date(data.data_penduduk_mutasi.tanggal_meninggal) : null,
				}
			}

			this.setState({
				// tmpImages: [],
				dt: {
					...this.state.dt,
					id: data.id,
					id_kk: data.id_kk,
					nama: data.nama,
					alamat: data.alamat,
					id_keldes: data.id_keldes,
					tempat_lahir: data.tempat_lahir,
					tanggal_lahir: data.tanggal_lahir,
					jk: data.jk,
					status_kehidupan: data.status_kehidupan,
					status_perkawinan: data.status_perkawinan,
					shdk: data.shdk,
					agama: data.agama,
					pendidikan_terakhir: data.pendidikan_terakhir,
					pekerjaan: data.pekerjaan,
					nama_ibu_kandung: data.nama_ibu_kandung,
					status_penduduk: data.status_penduduk,
					nama_ayah_kandung: data.nama_ayah_kandung,

					dapat_membaca: extra.dapat_membaca,
					kewarganegaraan: extra.kewarganegaraan,

					datang_dari: extra2.datang_dari,
					pindah_ke: extra2.pindah_ke,
					keterangan: extra2.keterangan,
					tanggal_datang: extra2.tanggal_datang,
					tanggal_pindah: extra2.tanggal_pindah,
					tanggal_meninggal: extra2.tanggal_meninggal,
				},
				detailPenduduk: {
					value: data.id,
					label: `${data.id} | ${data.nama}`,
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
	}

	cariData = (e) => {
		if (e.key === 'Enter') {
			let txt = e.target.value
			this.setState({
				textCari: txt.trim(),
				loading: true
			});
			setTimeout(
				function () {
					this.fetch();
				}.bind(this),
				500
			);
		}
	};

	changeInputText = (e, fld) => {
		this.setState({
			dt: {
				...this.state.dt,
				[fld]: e.target.value
			}
		})
	};

	gantiTgl = (date, fld) => {
		let value = null
		if (typeof date._isValid !== 'undefined') {
			value = new Date(date.format('YYYY-MM-DD'))
			// this.setState({
			// 	dt: {
			// 		...this.state.dt,
			// 		[fld]: new Date(date.format('YYYY-MM-DD'))
			// 	}
			// })
		}
		this.setState({
			dt: {
				...this.state.dt,
				[fld]: value
			}
		})
	}

	downloadSurat = () => {
		let token = sessionStorage.getItem("access_token")
			? sessionStorage.getItem("access_token")
			: "public";

		fetch(API_URL + 'buku-rekapitulasi-jumlah-penduduk/cetak?bulan=' + this.state.bulanCetak.value + "&tahun=" + this.state.tahunCetak.value, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/pdf',
				'Authorization': 'Bearer ' + token,
			},
		})
			// .then((response) => response.blob())
			.then((response) => {
				if (response.status == 200) {
					return response.blob()
				}
				this.setState({
					loading: false,
					show: true,
					basicType: 'danger',
					basicTitle: 'Data Penduduk ' + JENIS_DESA,
					pesanAlert: 'Gagal cetak surat'
				});
				throw new Error('Something went wrong');
			})
			.then((blob) => {
				// Create blob link to download
				const url = window.URL.createObjectURL(
					new Blob([blob]),
				);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute(
					'download',
					`Buku Rekapitulasi Penduduk Bulan ${this.state.bulanCetak.value} Tahun ${this.state.tahunCetak.value}.pdf`,
				);

				// Append to html link element page
				document.body.appendChild(link);

				// Start download
				link.click();

				// Clean up and remove the link
				link.parentNode.removeChild(link);
				this.setState({
					loading: false,
				})
			})
			.catch((e) => {
				// console.log(e);
			})
			;
	}
	handleInputChangeNIK = (e, fld) => {
		console.log(e);
		Post("buku-rekapitulasi-jumlah-penduduk", null, { q: e }, datanik => {
			let frmNik = [];
			let tmplistPenduduk = {}
			datanik.data.results.data.forEach(dt => {
				frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
				tmplistPenduduk = {
					...tmplistPenduduk,
					[dt.id]: dt
				}
				this.setState({
					frmNik,
					listPenduduk: frmNik,
					tmplistPenduduk,
				})
			});

		});
	};

	changeSelectValue = (e, sel) => {
		this.setState({
			[sel]: e
		})
	}

	componentDidMount() {
		this.fetch()
		Get("buku-rekapitulasi-jumlah-penduduk", null, dtkat => {
			console.log(dtkat);
			if (dtkat.results) {
				// this.setState({ listPerangkat: dtkat.results })
				let frm = [];
				let tmplistPenduduk = {}
				dtkat.results.data.forEach(dt => {
					// if (dt.data_penduduk) {
					frm.push({ value: dt.id, label: `${dt.id} | ${dt.nama}` });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
					// }
				});
				console.log(frm);
				this.setState({ listPenduduk: frm, frmNik: frm, tmplistPenduduk });
			}
		});
		Get("buku-rekapitulasi-jumlah-penduduk/list-tahun", null, dtkat => {
			if (dtkat.results && dtkat.results.length > 0) {
				let listTahun = []
				dtkat.results.map((e) => {
					listTahun.push({ value: e, label: e })
				})

				this.setState({
					listTahun
				})

			}
		});
	}

	render() {
		var data = this.state.data;

		const columns = [
			{
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
			{
				dataField: 'tanggal_rekapitulasi',
				text: 'Tahun & Bulan',
				headerAlign: 'center',
				align: 'center',
				sort: false,
				formatter: (cell, row) => {
					const tahun = row.tanggal_rekapitulasi.substr(0, 4)
					const bulan = row.tanggal_rekapitulasi.substr(5, 2)
					
					return `${tahun} - ${bulan}`
				}
			},
			{
				dataField: 'data_dusun.nama',
				text: 'DUSUN',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'jumlah_anggota_keluarga',
				text: 'Jumlah Ang. Keluarga',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'jumlah_jiwa',
				text: 'Jumlah Jiwa',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			{
				dataField: 'jumlah_kk',
				text: 'Jumlah KK',
				headerAlign: 'center',
				align: 'center',
				sort: false
			},
			// {
			// 	dataField: 'data_penduduk_detail.keterangan',
			// 	text: 'Ket.',
			// 	headerAlign: 'center',
			// 	align: 'center',
			// 	sort: false
			// },
			{
				dataField: 'aksi',
				text: 'Aksi',
				headerAlign: 'center',
				align: 'center',
				formatter: function (cell, row) {
					return (
						<div style={{ minWidth: "61px" }}>
							{/* <Button
								size="xs"
								color="success"
								className="btn-icon mr-2"
								onClick={() => this.ubahData(row)}
							// disabled={btnAksi}
							>
								<i className="fa fa-pencil"></i>
							</Button>{" "} */}
							<Button
								size="xs"
								color="info"
								className="btn-icon mr-2"
								onClick={() => {
									this.setState({
										detailPreview: true,
										detailData: row
									})
								}}
							>
								<i className="fa fa-eye"></i>
							</Button>
							<Button
								size="xs"
								color="danger"
								className="btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlert
												showCancel
												confirmBtnText="Hapus"
												confirmBtnBsStyle="danger"
												cancelBtnBsStyle="success"
												type="danger"
												title="Yakin ingin hapus data ?"
												onCancel={this.hideAlert}
												onConfirm={() => {
													Delete('buku-rekapitulasi-jumlah-penduduk/delete', row.uuid, (res) => {
														if (res === 200) {
															this.setState({
																show: true,
																basicType: 'success',
																basicTitle: 'Data Rekapitulasi Jumlah Penduduk ' + JENIS_DESA,
																pesanAlert: 'Berhasil hapus data'
															});
															this.fetch()
														} else {
															this.setState({
																show: true,
																basicType: 'danger',
																basicTitle: 'Data Rekapitulasi Jumlah Penduduk ' + JENIS_DESA,
																pesanAlert: 'Gagal hapus data'
															});
														}
														this.setState({ alert: null })
													})
												}}
											>
												Proses ini tidak dapat dibatalkan!
											</SweetAlert>
										)
									});
								}}
								disabled={this.state.status.btnAksi}
							>
								<i className="fa fa-trash"></i>
							</Button>
						</div>
					)
				}.bind(this)
			}
		]

		return (
			<div>
				{/* <Breadcrumb title="Data Penduduk Desa" parent="Admin" /> */}
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>

				<SweetAlert
					show={this.state.loadingPreview}
					showCancel={false}
					showConfirm={false}
				>
					<div align="center">
						{/* <h5 className="modal-title mb-3" style={{ textAlign: "center", color: 'black' }}>Sedang memuat data...</h5> */}
						<img
							alt="loading"
							src={require("../../../assets/images/tes-loading.gif")}
							style={{
								borderRadius: "10px",
								width: '150px'
							}}
						/>
					</div>
				</SweetAlert>

				{this.state.alert}

				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<div className="card mb-0">
								<div className="card-header">
									<div className="row">
										<div className="col-sm-6 text-left">
											<Button
												size="sm"
												color="default"
												style={{ backgroundColor: '#FFC312' }}
												onClick={this.props.history.goBack}
											>
												<i className="fa fa-arrow-left"></i> Kembali
											</Button>
										</div>
										<div className="col-sm-6 text-right">
											<Button
												size="sm"
												color="info"
												className="btn-icon mr-2"
												onClick={() => {
													// this.setState({ loading: true })
													// this.downloadSurat()
													this.setState({ cetakPreview: true })
												}}
											>
												Cetak
											</Button>{" "}
											<Button
												size="sm"
												color="success"
												className="btn-square"
												onClick={() => {
													this.setState({
														judul: 'Tambah Rekapitulasi Data Penduduk ' + JENIS_DESA,
														dt: frmDex,
														tmpImages: ['kosong'],
														editMode: false,
														detailPenduduk: null,
														currentLocation: this.state.curStaticLocation
													});
													// document.getElementById('form-data').reset()
													this.bukaForm();
												}}
											>
												Tambah Data
											</Button>
										</div>
									</div>
								</div>

								<div className="card-body datatable-react custom-font-sm">
									{/* <div className="row">
										<div className="col-md-12"> */}
									{this.state.loading ? (
										<div className="row">
											<div className="col-sm-12" align="center">
												<img
													alt="loading"
													src={require("../../../assets/images/tes-loading.gif")}
													style={{
														borderRadius: "10px",
														width: '100px'
													}} />
											</div>
										</div>
									) : (
										<div className='row'>
											<div className="col-md-5 text-right">
												<input
													type="text"
													className="form-control"
													style={{ marginBottom: '15px' }}
													id="cariTable"
													placeholder={"Cari berdasarkan nama dusun"}
													defaultValue={this.state.textCari}
													onChange={(e) => {
														this.setState({ textCari: e.target.value })
													}}
													onKeyPress={this.cariData}
												/>
												<div className="clearBtnSearch" style={{ display: this.state.textCari !== '' ? 'inline' : '' }}>
													<span className='fa fa-close' style={{ fontSize: '1.3em', cursor: 'pointer' }} onClick={() => {
														this.setState({
															textCari: '',
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
														document.getElementById('cariTable').value = ''
													}} ></span>
												</div>
											</div>
											<div className="col-md-7" style={{ marginBottom: '15px' }}>
												<Button
													size="sm"
													color="info"
													className="btn-square"
													onClick={() => {
														this.setState({
															textCari: document.getElementById("cariTable").value,
															loading: true
														});
														setTimeout(
															function () {
																this.fetch();
															}.bind(this),
															500
														);
													}}
												>
													<i className="fa fa-search"></i>
												</Button>
											</div>
											{data.length > 0 ? (
												<>
													<div className="col-md-12">
														<BootstrapTable
															keyField="id"
															data={data}
															columns={columns}
														/>
														<div className="pull-right text-white">
															{this.state.awal}
															{this.state.sebelum}
															{this.state.hal.map(dt => {
																return dt;
															})}
															{this.state.setelah}
															{this.state.akhir}
														</div>
													</div>
												</>
											) : (
												<div className="col-md-12">
													<h6 className="text-center mb-2 mt-2">Data tidak ditemukan</h6>
												</div>
											)}
										</div>
									)}
									{/* </div>
									</div> */}
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<Modal
					open={this.state.cetakPreview ? true : false}
					onClose={() => {
						this.setState({ cetakPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '40%', maxWidth: 'unset' } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.handleCetak(e) }}>
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Cetak Data Rekapitulasi Jumlah Penduduk {JENIS_DESA}</h5>
						</div>
						<div className="modal-body">
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Tahun</Label>
									{/* <input
										className="form-control"
										id="tahun"
										type="number"
										min={2010}
										placeholder="Masukkan tahun"
										defaultValue={this.state.tahunCetak}
										onChange={(e) => {
											this.setState({
												tahunCetak: e.target.value
											})
										}}
										required
									/> */}
									<ReactSelect
										classNamePrefix="select"
										onChange={e => {
											this.changeSelectValue(e, "tahunCetak")
										}}
										defaultValue={this.state.tahunCetak}
										value={this.state.tahunCetak}
										name="nik"
										options={this.state.listTahun}
										placeholder="Pilih Tahun"
										// isClearable
									/>
								</Col>
							</div>
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Bulan</Label>
									<ReactSelect
										classNamePrefix="select"
										// isClearable
										onChange={e => {
											// this.setState({
											// 	bulanCetak: e
											// })
											this.changeSelectValue(e, "bulanCetak")
										}}
										defaultValue={this.state.bulanCetak}
										value={this.state.bulanCetak}
										options={[
											{ value: '1', label: 'Januari' },
											{ value: '2', label: 'Februari' },
											{ value: '3', label: 'Maret' },
											{ value: '4', label: 'April' },
											{ value: '5', label: 'Mei' },
											{ value: '6', label: 'Juni' },
											{ value: '7', label: 'Juli' },
											{ value: '8', label: 'Agustus' },
											{ value: '9', label: 'September' },
											{ value: '10', label: 'Oktober' },
											{ value: '11', label: 'November' },
											{ value: '12', label: 'Desember' },
										]}
										placeholder={"Pilih Bulan"}
									/>
								</Col>
							</div>
						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								onClick={() => {
									this.setState({ cetakPreview: false })
								}}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success">
								Cetak
							</button>
						</div>
					</Form>
				</Modal>

				<Modal
					open={this.state.detailPreview ? true : false}
					onClose={() => {
						this.setState({ detailPreview: false })
					}}
					closeOnEsc={true}
					closeOnOverlayClick={true}
					styles={{ modal: { width: '50%', maxWidth: 'unset' } }}
				>
					<div className="modal-header">
						<h5 className="modal-title" style={{ fontWeight: 'bold' }}>Detail Data Penduduk {JENIS_DESA}</h5>
					</div>
					<div className="modal-body">
						<div className="row">
							<div className="col-md-12">
								{this.state.detailData ? (
									<>
										<div className="table-responsive">
											<table className='detail-dokumen-administrasi'>
												<tbody>
													<tr>
														<td width="280">Tanggal Rekap</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.tanggal_rekapitulasi}</span></td>
													</tr>
													<tr>
														<td width="280">Nama Dusun</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.data_dusun.nama}</span></td>
													</tr>

													<tr>
														<td colSpan={3}>
															<hr className='mt-1 mb-1' />
														</td>
													</tr>
													<tr>
														<td><b>Jumlah Penduduk Awal Bulan</b></td>
														<td></td>
														<td></td>
													</tr>
													<tr>
														<td width="280">WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.wni_l}</span></td>
													</tr>
													<tr>
														<td width="280">WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.wni_p}</span></td>
													</tr>
													<tr>
														<td width="280">WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.wna_l}</span></td>
													</tr>
													<tr>
														<td width="280">WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.wna_p}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah KK</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_kk}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah Anggota Keluarga</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_anggota_keluarga}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah Jiwa</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_jiwa}</span></td>
													</tr>

													<tr>
														<td colSpan={3}>
															<hr className='mt-1 mb-1' />
														</td>
													</tr>
													<tr>
														<td><b>Tambahan Bulan Ini</b></td>
														<td></td>
														<td></td>
													</tr>
													<tr>
														<td width="280">Lahir WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.lahir_wni_l}</span></td>
													</tr>
													<tr>
														<td width="280">Lahir WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.lahir_wni_p}</span></td>
													</tr>
													<tr>
														<td width="280">Lahir WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.lahir_wna_l}</span></td>
													</tr>
													<tr>
														<td width="280">Lahir WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.lahir_wna_p}</span></td>
													</tr>
													<tr>
														<td width="280">Datang WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.datang_wni_l}</span></td>
													</tr>
													<tr>
														<td width="280">Datang WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.datang_wni_p}</span></td>
													</tr>
													<tr>
														<td width="280">Datang WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.datang_wna_l}</span></td>
													</tr>
													<tr>
														<td width="280">Datang WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.datang_wna_p}</span></td>
													</tr>

													<tr>
														<td colSpan={3}>
															<hr className='mt-1 mb-1' />
														</td>
													</tr>
													<tr>
														<td><b>Pengurangan Bulan Ini</b></td>
														<td></td>
														<td></td>
													</tr>
													<tr>
														<td width="280">Meninggal WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.meninggal_wni_l}</span></td>
													</tr>
													<tr>
														<td width="280">Meninggal WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.meninggal_wni_p}</span></td>
													</tr>
													<tr>
														<td width="280">Meninggal WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.meninggal_wna_l}</span></td>
													</tr>
													<tr>
														<td width="280">Meninggal WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.meninggal_wna_p}</span></td>
													</tr>
													<tr>
														<td width="280">Pindah WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.pindah_wni_l}</span></td>
													</tr>
													<tr>
														<td width="280">Pindah WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.pindah_wni_p}</span></td>
													</tr>
													<tr>
														<td width="280">Pindah WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.pindah_wna_l}</span></td>
													</tr>
													<tr>
														<td width="280">Pindah WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.pindah_wna_p}</span></td>
													</tr>

													<tr>
														<td colSpan={3}>
															<hr className='mt-1 mb-1' />
														</td>
													</tr>
													<tr>
														<td><b>Jumlah Penduduk Akhir Bulan</b></td>
														<td></td>
														<td></td>
													</tr>
													<tr>
														<td width="280">WNI Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_wni_akhir_bulan_l}</span></td>
													</tr>
													<tr>
														<td width="280">WNI Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_wni_akhir_bulan_p}</span></td>
													</tr>
													<tr>
														<td width="280">WNA Laki-Laki</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_wna_akhir_bulan_l}</span></td>
													</tr>
													<tr>
														<td width="280">WNA Perempuan</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_wna_akhir_bulan_p}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah KK</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_kk_akhir_bulan}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah Anggota Keluarga</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_anggota_keluarga_akhir_bulan}</span></td>
													</tr>
													<tr>
														<td width="280">Jumlah Jiwa</td>
														<td width="50" className="text-center">:</td>
														<td><span>{this.state.detailData.jumlah_jiwa_akhir_bulan}</span></td>
													</tr>

												</tbody>
											</table>
										</div>
									</>
								) : ''}
							</div>
						</div>
					</div>
				</Modal>
				<Modal
					open={this.state.status.form}
					onClose={this.tutupForm}
					closeOnEsc={false}
					closeOnOverlayClick={false}
					styles={{ modal: { width: '30%', maxWidth: "unset" } }}
				>
					<Form id="form-data" className="theme-form" onSubmit={(e) => { this.simpan(e) }}>
						<input className="form-control" id="uuid" type="hidden" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid} />
						<div className="modal-header">
							<h5 className="modal-title" style={{ fontWeight: 'bold' }}>{this.state.judul}</h5>
						</div>
						<div className="modal-body">
							{/* <input
								className="form-control"
								id="uuid"
								type="hidden"
								placeholder="UUID"
								defaultValue={this.state.dt.uuid}
								value={this.state.dt.uuid}
							/> */}

							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Bulan</Label>
									<input
										className="form-control"
										id="tahun"
										type="number"
										min={2010}
										placeholder="Masukkan tahun"
										defaultValue={this.state.dt.tahun}
										value={this.state.dt.tahun}
										onChange={(e) => {
											this.setState({
												dt: {
													...this.state.dt,
													tahun: e.target.value
												}
											})
										}}
										required
									/>
								</Col>
							</div>
							<div className="form-row">
								<Col sm="12 mb-2">
									<Label htmlFor="validationCustom05">Bulan</Label>
									<ReactSelect
										classNamePrefix="select"
										// isClearable
										onChange={e => {
											this.setState({
												dt: {
													...this.state.dt,
													bulan: e
												}
											})
										}}
										defaultValue={this.state.dt.bulan}
										value={this.state.dt.bulan}
										options={[
											{
												value: "1",
												label: "Januari"
											},
											{
												value: "2",
												label: "Februari"
											},
											{
												value: "3",
												label: "Maret"
											},
											{
												value: "4",
												label: "April"
											},
											{
												value: "5",
												label: "Mei"
											},
											{
												value: "6",
												label: "Juni"
											},
											{
												value: "7",
												label: "Juli"
											},
											{
												value: "8",
												label: "Agustus"
											},
											{
												value: "9",
												label: "September"
											},
											{
												value: "10",
												label: "Oktober"
											},
											{
												value: "11",
												label: "November"
											},
											{
												value: "12",
												label: "Desember"
											},
										]}
										placeholder={"Pilih Bulan"}
									/>
								</Col>
							</div>

						</div>
						<div className="modal-footer">
							<button
								type="button"
								className="btn btn-warning"
								disabled={this.state.status.btnForm}
								onClick={this.tutupForm}
							>
								Tutup
							</button>
							<button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>
								Simpan
							</button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

export default MenuB3;
